import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation, useQueryClient } from "react-query";

export const useDeleteVessel = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const deleteVessel = async (vesselId) => {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/vessel/delete/${vesselId}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorResponse = await response.json();
      throw new Error(errorResponse.message || "Failed to delete vessel");
    }

    return response.json();
  };

  return useMutation(deleteVessel, {
    onSuccess: () => {
      queryClient.invalidateQueries("vessels");
    },
    onError: (error) => {
      console.error("Error deleting vessel:", error);
    },
  });
};
